// Kanonischer Zeitraum-Titel für alle Topcenter/Toolbars, die eine
// Datumsspanne anzeigen (Kalender-Woche, Team-Planung, Disposition):
//   „KW 28 · 06.–12. Juli 2026"          (eine Woche, gleicher Monat)
//   „KW 27 · 29. Juni – 05. Juli 2026"   (Monatswechsel)
//   „KW 28–31 · 06. Juli – 02. August 2026" (mehrwöchig, Dispo-Monat)
// Pure Funktionen — keine Locale-Optionen nach außen, de-DE ist gesetzt.

import { isoWeek } from './calendar'

const dd = (d: Date) => String(d.getDate()).padStart(2, '0')
const monthLong = (d: Date) => d.toLocaleDateString('de-DE', { month: 'long' })

/** Datumsspanne ohne KW-Präfix: Monat/Jahr werden nur wiederholt, wenn sie
 *  sich zwischen Start und Ende unterscheiden (kompakteste eindeutige Form). */
export function formatDateRange(start: Date, end: Date): string {
  const sameYear = start.getFullYear() === end.getFullYear()
  const sameMonth = sameYear && start.getMonth() === end.getMonth()
  if (sameMonth) return `${dd(start)}.–${dd(end)}. ${monthLong(end)} ${end.getFullYear()}`
  if (sameYear)
    return `${dd(start)}. ${monthLong(start)} – ${dd(end)}. ${monthLong(end)} ${end.getFullYear()}`
  return `${dd(start)}. ${monthLong(start)} ${start.getFullYear()} – ${dd(end)}. ${monthLong(end)} ${end.getFullYear()}`
}

/** Kanonischer Zeitraum-Titel „KW n · <Spanne>"; überspannt der Zeitraum
 *  mehrere ISO-Wochen, wird das KW-Präfix zur Spanne („KW 28–31"). */
export function periodTitle(start: Date, end: Date): string {
  const kwStart = isoWeek(start)
  const kwEnd = isoWeek(end)
  const kw = kwStart === kwEnd ? `KW ${kwStart}` : `KW ${kwStart}–${kwEnd}`
  return `${kw} · ${formatDateRange(start, end)}`
}
